import Phaser from 'phaser';

export class BootScene extends Phaser.Scene {
  static readonly KEY = 'BootScene';
  static readonly BG_LOBBY = 'bg-lobby';
  static readonly BG_GAME = 'bg-game';

  constructor() {
    super(BootScene.KEY);
  }

  preload(): void {
    // Fondos cinemáticos placeholder (no definitivos). Vite sirve desde
    // `public/assets/` bajo el base path /pc/, así que ruta relativa.
    this.load.image(BootScene.BG_LOBBY, 'assets/bg-lobby.png');
    this.load.image(BootScene.BG_GAME, 'assets/bg-game.png');
  }

  create(): void {
    this.scene.start('LobbyScene');
  }
}
